import { useFetchUser } from '@jooxter/core';
import { Navigate, Outlet } from 'react-router';
import { JxtLoader } from '@jooxter/ui';
import { JSX } from 'react';
import { getLandingRoute } from './helpers';
import { usePermissions } from '@jooxter/permissions';

export const OnboardingNotDoneGuard = (): JSX.Element => {
  const { user } = useFetchUser();
  const {
    permissions: { booking, home },
  } = usePermissions();
  const allowOnboarding = !user?.setupDone && booking;

  if (!user) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <JxtLoader />
      </div>
    );
  }

  return allowOnboarding ? <Outlet /> : <Navigate to={getLandingRoute(home)} replace />;
};
